import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import Tooltip from './UTMFields/Tooltip';

const tips = {
  campaign:
    'Campaign Name + Audience + Strategic Priority — i.e. Paratransit Data Tool + Propane Industry + Market Growth-Autogas.',
  medium: 'Method used to drive traffic.',
  source:
    'Name of the channel, site, newsletter, email type on which link is to be placed',
  date:
    'Date of PERC Update, newsletter, or other dated material, where applicable.',
  content: 'Ad Content or Content of article/post.',
  keyword:
    'Open field for additional context — i.e. Industry Engagement Calendar.'
};

export default function DetailHeaders() {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isTableSticky, setIsTableSticky] = useState(false);

  const handleScroll = () => {
    const windowScrollPosition =
      document.body.scrollTop || document.documentElement.scrollTop;
    setScrollPosition(windowScrollPosition);
  };

  const applySticky = () => {
    if (scrollPosition >= 147) {
      if (!isTableSticky) {
        setIsTableSticky(true);
      }
    } else {
      setIsTableSticky(false);
    }
  };

  useEffect(() => {
    applySticky();
  }, [scrollPosition]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
  }, []);

  // only display if group_name is set
  return (
    <div
      className={`utm__table-header ${
        isTableSticky ? 'utm__table-header--sticky' : ''
      }`}
    >
      <div className="grid u--margin-0 utm__list-headers">
        <div className="grid__col-lg-2">Destination URL</div>
        <div className="grid__col-lg-2">
          Campaign
          <Tooltip content={tips.campaign} direction="bottom" tipClass="utm">
            <FontAwesomeIcon icon={faQuestionCircle} />
          </Tooltip>
        </div>
        <div className="grid__col-lg-2">
          Medium
          <Tooltip content={tips.medium} tipClass="utm">
            <FontAwesomeIcon icon={faQuestionCircle} />
          </Tooltip>
        </div>
        <div className="grid__col-lg-2">
          Source
          <Tooltip content={tips.source} tipClass="utm">
            <FontAwesomeIcon icon={faQuestionCircle} />
          </Tooltip>
        </div>
        <div className="grid__col-lg-1">
          Date
          <Tooltip content={tips.date} tipClass="utm">
            <FontAwesomeIcon icon={faQuestionCircle} />
          </Tooltip>
        </div>
        <div className="grid__col-lg-1">
          Content
          <Tooltip content={tips.content} tipClass="utm">
            <FontAwesomeIcon icon={faQuestionCircle} />
          </Tooltip>
        </div>
        <div className="grid__col-lg-1">
          Keyword
          <Tooltip content={tips.keyword} tipClass="utm">
            <FontAwesomeIcon icon={faQuestionCircle} />
          </Tooltip>
        </div>
        <div className="grid__col-lg-1">Actions</div>
      </div>
    </div>
  );
}
